import { render, staticRenderFns } from "./KhoTLT.vue?vue&type=template&id=d83cbbba&scoped=true&"
import script from "./KhoTLT.vue?vue&type=script&lang=js&"
export * from "./KhoTLT.vue?vue&type=script&lang=js&"
import style0 from "./KhoTLT.vue?vue&type=style&index=0&id=d83cbbba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83cbbba",
  null
  
)

export default component.exports